var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHangman7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    width: 298.232,
    height: 291,
    viewBox: "0 0 298.232 291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(-16059.232 -14400)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2987",
    "data-name": "Rectangle 2987",
    width: 5,
    height: 289,
    rx: 2.5,
    transform: "translate(16107.232 14400)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2974",
    "data-name": "Rectangle 2974",
    width: 5,
    height: 61.733,
    transform: "translate(16150.859 14400.247) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2966",
    "data-name": "Rectangle 2966",
    width: 5,
    height: 298.232,
    rx: 2.5,
    transform: "translate(16357.465 14686) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2988",
    "data-name": "Rectangle 2988",
    width: 187,
    height: 5,
    rx: 2.5,
    transform: "translate(16107.232 14400)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2989",
    "data-name": "Rectangle 2989",
    width: 5,
    height: 49,
    rx: 2.5,
    transform: "translate(16289.232 14401)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2970",
    "data-name": "Rectangle 2970",
    width: 5,
    height: 56,
    rx: 2.5,
    transform: "translate(16289.197 14498.247) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2967",
    "data-name": "Rectangle 2967",
    width: 5,
    height: 56,
    rx: 2.5,
    transform: "translate(16291.197 14565.247) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2971",
    "data-name": "Rectangle 2971",
    width: 5,
    height: 56,
    rx: 2.5,
    transform: "translate(16290.732 14501.782) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M5,2.5v51a2.5,2.5,0,0,1-5,0V2.5C0,1.119,5,1.119,5,2.5Z",
    transform: "translate(16288.732 14568.783) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    transform: "translate(16263.732 14445.247)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2990",
    "data-name": "Rectangle 2990",
    width: 5,
    height: 73,
    rx: 2.5,
    transform: "translate(16289.232 14498)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangman7);
export default __webpack_public_path__ + "static/media/hangman-7.cb1184d7f5bf38864df40200725c1de7.svg";
export { ForwardRef as ReactComponent };